/**
 *
 * app.js
 *
 * This is the entry file for the application, mostly just setup and boilerplate
 * code. Routes are configured at the end of this file!
 *
 */
import offlineRuntime from 'offline-plugin/runtime';
import injectTapEventPlugin from 'react-tap-event-plugin';
import debugFactory from 'debug';
import moment from 'moment';
import { initStart } from './commons/initializers/initDucks';
import offlineManager from './commons/offline/offlineManager';
import persitStoreCreator from './commons/offline/persistStoreProvider';

import './commons/styles';

import store from './commons/store/store';

import attachments from './attachments/attachments';
import initExternalDependencies from './commons/config/initExternalDependencies';

if (process.env.NODE_ENV === 'development') {
  debugFactory.enable('*');
}
/*
 * Initializing modules whose configuration is provided by the server.
 */
initExternalDependencies();

offlineManager();

const debug = debugFactory('bootstrap');

/*
 * By default, "the "fr" locale is used when formatting
 * dates with moment.
 */
moment.locale('fr');

offlineRuntime.install({
  onUpdating: () => {
    debug('SW Event: onUpdating');
  },
  onUpdateReady: () => {
    debug('SW Event: onUpdateReady');
    // Tells to new SW to take control immediately
    offlineRuntime.applyUpdate();
  },
  onUpdated: () => {
    debug('SW Event: onUpdated');
    // Reload the webpage to load into the new version
    window.location.reload();
  },
  onUpdateFailed: () => {
    debug('SW Event: onUpdateFailed');
  },
});

injectTapEventPlugin();

// Here we start the browser persistence
const callback = () => {
  store.dispatch(initStart(store));
};
persitStoreCreator(store, callback);

attachments.initialize();




// WEBPACK FOOTER //
// ./book/src/app.js